// Ionicons, individually tree-shaken as inline SVG components — never the
// `ionicons` custom-element bundle or the webfont (plan.md "Bundle budget"
// section: "Ionicons as individually tree-shaken SVG strings, never the
// custom-element bundle or the webfont"). Each icon below is copied from the
// Ionicons v7 "outline" set (MIT licensed) as a minimal path, so importing
// one icon never pulls in the other 1,300+.
//
// Add new icons the same way: one named export per icon, one <svg> literal,
// no shared runtime beyond React itself.

import type { SVGProps } from 'react';

export function CheckmarkIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 512 512" fill="none" stroke="currentColor" strokeWidth={48} strokeLinecap="round" strokeLinejoin="round" {...props}>
      <path d="M416 128 192 384l-96-96" />
    </svg>
  );
}

export function HomeIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 512 512" fill="none" stroke="currentColor" strokeWidth={32} strokeLinecap="round" strokeLinejoin="round" {...props}>
      <path d="M80 212v236a16 16 0 0 0 16 16h96V328a24 24 0 0 1 24-24h80a24 24 0 0 1 24 24v136h96a16 16 0 0 0 16-16V212" />
      <path d="m480 256-224-176-224 176" strokeLinejoin="round" />
    </svg>
  );
}

export function PersonIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 512 512" fill="none" stroke="currentColor" strokeWidth={32} strokeLinecap="round" strokeLinejoin="round" {...props}>
      <path d="M344 144c-3.92 52.87-38 96-88 96s-84.15-43.12-88-96c-4-55 35-96 88-96s92 42 88 96Z" />
      <path d="M256 304c-87.61 0-160.71 34.24-172.18 137.89A16 16 0 0 0 96 460h320a16 16 0 0 0 12.18-18.11C416.71 338.24 343.61 304 256 304Z" />
    </svg>
  );
}

export function ChevronBackIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 512 512" fill="none" stroke="currentColor" strokeWidth={48} strokeLinecap="round" strokeLinejoin="round" {...props}>
      <path d="M328 112 184 256l144 144" />
    </svg>
  );
}

export function ChevronForwardIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 512 512" fill="none" stroke="currentColor" strokeWidth={48} strokeLinecap="round" strokeLinejoin="round" {...props}>
      <path d="m184 112 144 144-144 144" />
    </svg>
  );
}

export function DownloadIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 512 512" fill="none" stroke="currentColor" strokeWidth={32} strokeLinecap="round" strokeLinejoin="round" {...props}>
      <path d="M336 176h40a40 40 0 0 1 40 40v208a40 40 0 0 1-40 40H136a40 40 0 0 1-40-40V216a40 40 0 0 1 40-40h40" />
      <path d="M256 320V64M184 192l72 72 72-72" />
    </svg>
  );
}

export function PrintIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 512 512" fill="none" stroke="currentColor" strokeWidth={32} strokeLinecap="round" strokeLinejoin="round" {...props}>
      <rect x="128" y="320" width="256" height="144" rx="0" />
      <path d="M128 240V64h192l64 64v112M400 240H112a48 48 0 0 0-48 48v96a32 32 0 0 0 32 32h32M480 240H112" />
    </svg>
  );
}

export function CalendarIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 512 512" fill="none" stroke="currentColor" strokeWidth={32} strokeLinecap="round" strokeLinejoin="round" {...props}>
      <rect x="48" y="80" width="416" height="384" rx="32" />
      <path d="M128 48v64M384 48v64M48 192h416" strokeLinecap="round" />
    </svg>
  );
}

export function SearchIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 512 512" fill="none" stroke="currentColor" strokeWidth={32} strokeLinecap="round" strokeLinejoin="round" {...props}>
      <circle cx="221.09" cy="221.09" r="141.09" />
      <path d="M338.29 338.29 448 448" />
    </svg>
  );
}

export function AlertIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 512 512" fill="none" stroke="currentColor" strokeWidth={32} strokeLinecap="round" strokeLinejoin="round" {...props}>
      <path d="M85.57 446.25h340.86a32 32 0 0 0 28.17-47.17L284.18 82.58c-12.09-22.44-44.27-22.44-56.36 0L57.4 399.08a32 32 0 0 0 28.17 47.17Z" />
      <path d="M250.26 195.39v113.63M256 397.25a20 20 0 1 1 20-20 20 20 0 0 1-20 20Z" strokeLinejoin="round" />
    </svg>
  );
}
